<template>
  <b-modal
    id="match-done-modal"
    class="match-done-full-screen-modal"
    header-class="match-done-modal-header"
    ref="modal"
    centered
    no-close-on-esc
    no-close-on-backdrop
  >

    <template #modal-header="{ close }">
      <div  class="match-done-modal-header-content step4 w-100">
        <img :src="require(`@/assets/images/b122/img-watcher-right.png`)" class="match-done-modal-img" >
      </div>
    </template>

    <h1 class="green-o page-title mb-4"
        v-html="didInsist ? $t('verify.match.done.dialog.insist_title') : $t('verify.match.done.dialog.title')"/>

    <p class="content" v-html="didInsist ? $t('verify.match.done.dialog.insist_description') : $t('verify.match.done.dialog.description')"></p>

    <template #modal-footer="{ ok, cancel, hide }">
      <div class="w-100 d-flex">
        <b-button @click="onAddRIBClicked($event)"  class="w-100 mr-2" variant="secondary">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{$t('add.RIB')}}</span>
          </div>
        </b-button>
        <b-button  class="w-100" variant="primary"  @click="onEndClicked($event)">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{$t('Finish')}}</span>
          </div>
        </b-button>
      </div>
    </template>

  </b-modal>
</template>

<script>
export default {
  props:{
    didInsist: Boolean,
  },

  emits:[
    'onAddRIBClicked',
    'onEndClicked'
  ],

  data() {
    return {};
  },

  methods: {
    onAddRIBClicked(){
      this.$emit('onAddRIBClicked')
    },

    onEndClicked(){
      this.$emit('onEndClicked')
    },
  },
};
</script>

<!-- not scoped car modal --><style>

#match-done-modal .modal-header{
  background-color: var(--main-black-light) !important;
  padding-bottom: 0;
}

#match-done-modal .modal-content,
#match-done-modal .modal-body,
#match-done-modal .modal-footer{
  background-color: var(--main-black-dark);
}

#match-done-modal .match-done-modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-bottom: none;
}

.match-done-modal-img {
  max-width: 200px;
  min-width: 100px;
  z-index: 1;
}

#match-done-modal .modal-text{
  color: var(--main-grey-medium);
}

.match-done-modal-header {
  background-color: var(--main-black-medium) !important;
  position: relative;
  margin-top: -20px;
  margin-right: -20px;
  margin-left: -20px;
}

#match-done-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

.match-done-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}
.match-done-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

.green-o {
  color: var(--main-green-medium);
}

@media (max-width: 767px) {
  #match-done-modal .modal-content {
    display: flex;
    overflow: auto;
    padding: 10px;
  }
  #match-done-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
  #match-done-modal .modal-header {
    padding-top: 0;
  }
  .match-done-modal-img {
    margin-top: 20px;
    align-self: end;
  }
  #match-done-modal .modal-content {
    margin: 8px;
  }
  #match-done-modal .modal-text, #match-done-modal {
    padding: 10px;
  }
  #match-done-modal .match-done-modal-img {
    max-width: 100px;
  }
}


</style>



// WEBPACK FOOTER //
// src/views/match/MatchDoneModal.vue